module.exports = require('./dist/component')
